import { render, staticRenderFns } from "./VChatDropdown.vue?vue&type=template&id=066bc779&"
import script from "./VChatDropdown.vue?vue&type=script&lang=ts&"
export * from "./VChatDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./VChatDropdown.vue?vue&type=style&index=0&id=066bc779&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports